export default __webpack_public_path__ + "media/images/features/ja/map_line_2-77d3cf7a7d4ef49befec1c059a5e4c84.png";